/* eslint-disable */

import React, { useState } from 'react';
import { 
  TextField, Button, Typography, Stack, Alert, 
  Box, Container, Fade, InputAdornment,
  Card, CardContent, Divider
} from '@mui/material';
import { Email, Lock, Login, Dashboard } from '@mui/icons-material';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from './firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

const handleLogin = async () => {
  setError('');
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const userRef = doc(db, 'user', user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      setError('Kein Benutzerprofil gefunden. Kontaktieren Sie den Administrator.');
      return;
    }

    const userData = userSnap.data();

    if (userData.role === 'admin') {
      navigate('/belege');
    } else {
      setError('Keine gültige Benutzerrolle gefunden. Kontaktieren Sie den Administrator.');
    }
  } catch (err) {
    // Map Firebase error codes to user-friendly messages
    const errorMessages = {
      'auth/invalid-credential': 'E-Mail oder Passwort ist falsch.',
      'auth/user-not-found': 'Kein Benutzer mit dieser E-Mail gefunden.',
      'auth/wrong-password': 'Das Passwort ist falsch.',
      'auth/too-many-requests': 'Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.',
      'auth/user-disabled': 'Dieses Konto wurde deaktiviert.',
      'auth/invalid-email': 'Ungültige E-Mail-Adresse.',
    };
    setError(errorMessages[err.code] || 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
  }
};


  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%)
        `,
        zIndex: 0
      }} />

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Fade in={true} timeout={800}>
          <Card sx={{
            borderRadius: 4,
            boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
            backdropFilter: 'blur(10px)',
            background: 'rgba(255, 255, 255, 0.95)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <CardContent sx={{ p: 6 }}>
              {/* Header */}
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Box sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 3,
                  boxShadow: '0 10px 20px rgba(102, 126, 234, 0.3)'
                }}>
                  <Dashboard sx={{ fontSize: 40, color: 'white' }} />
                </Box>
                
                <Typography variant="h4" fontWeight="700" sx={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1
                }}>
                  Belegverwaltung
                </Typography>
                
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  Melden Sie sich an, um fortzufahren
                </Typography>

              </Box>

              {/* Error Alert */}
              {error && (
                <Fade in={!!error}>
                  <Alert 
                    severity="error" 
                    sx={{ 
                      mb: 3, 
                      borderRadius: 2,
                      '& .MuiAlert-icon': {
                        fontSize: 20
                      }
                    }}
                  >
                    {error}
                  </Alert>
                </Fade>
              )}

              {/* Login Form */}
              <Stack spacing={3}>
                <TextField
                  label="E-Mail-Adresse"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email sx={{ color: 'text.secondary' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      fontSize: '16px',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.main',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '16px',
                    }
                  }}
                />

                <TextField
                  label="Passwort"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock sx={{ color: 'text.secondary' }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      fontSize: '16px',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.main',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '16px',
                    }
                  }}
                />

                <Button
                  variant="contained"
                  onClick={handleLogin}
                  size="large"
                  startIcon={<Login />}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    fontSize: '16px',
                    fontWeight: 600,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 8px 16px rgba(102, 126, 234, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                      boxShadow: '0 12px 24px rgba(102, 126, 234, 0.4)',
                      transform: 'translateY(-1px)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  Anmelden
                </Button>
              </Stack>

              {/* Footer */}
              <Box sx={{ textAlign: 'center', mt: 4 }}>
                <Divider sx={{ mb: 3 }} />
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Container>
    </Box>
  );
}

export default LoginPage;
